// opervex-frontend/src/Opervex/Report/GoodsMovementFull.js

class GoodsMovementFull {
  #api;

  constructor(api) {
    this.#api = api;
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "operation",
        label: "Operação",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "operationText",
        label: "Texto Operação",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "documentDate",
        label: "Data do documento",
        type: "dateOnly",
        visible: true,
        hidden: false,
      },
      {
        key: "createOn",
        label: "Data de Criação",
        type: "date",
        visible: true,
        hidden: false,
      },
      {
        key: "idOriginDeposit",
        label: "Depósito de origem",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "originDepText",
        label: "Texto do depósito de origem",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "idDestinationDeposit",
        label: "Depósito de destino",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "targetDepText",
        label: "Texto do depósito de destino",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "reference",
        label: "Referência",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "item",
        label: "Item",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "product",
        label: "Produto",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "productText",
        label: "Descrição do produto",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "serialNumber",
        label: "Nº de série",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "mac",
        label: "MAC",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "quantity",
        label: "Quantidade",
        type: "decimal",
        decimals: 3,
        visible: true,
        hidden: false,
      },
      {
        key: "protocol",
        label: "Protocolo - OS",
        type: "string",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default GoodsMovementFull;
